export const environment = {
  production: false,
  title: 'More Stuff (Test)',
  apiServiceUrl: 'https://api.morestuff.net/api/service',
  emailErrors: true,
  authUser: 'morestuff',
  authPwd: 'msI#1svc',
  userTimeoutMinutes: 15,
};
